import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type Asset from 'stores/Asset';

import AssetRowButtons from './AssetRowButtons';
import AssetTypeIcon from './AssetTypeIcon';

const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  padding: 9px 16px;
`;

const InfoContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 9px;
`;

const ActionsContainer = styled.div`
  display: flex;
`;

interface NameLabelProps {
  $isLoading?: boolean;
}

const NameLabel = styled.span<NameLabelProps>`
  font-weight: bold;
  opacity: ${(p) => (p.$isLoading ? 0.5 : 1)};
`;

export interface AssetSummaryRowProps {
  asset: Asset;
}

function AssetSummaryRow({ asset }: AssetSummaryRowProps) {
  return (
    <Container>
      <InfoContainer>
        <AssetTypeIcon assetType={asset.data.type} />
        <NameLabel $isLoading={asset.loading}>{asset.filename}</NameLabel>
      </InfoContainer>

      <ActionsContainer>
        <AssetRowButtons asset={asset} />
      </ActionsContainer>
    </Container>
  );
}

export default observer(AssetSummaryRow);
